function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EgyptFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4193",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4193)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4193",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4193)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#BF2714"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#272727"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.19527 10.6652L9.94448 10.6995L9.75642 14.8019L9.0072 14.7675L9.19527 10.6652Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.9781 10.9198L10.7269 10.9621L10.5388 14.2886L9.79004 14.2463L9.9781 10.9198Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.7614 11.1689L11.5089 11.2303L11.3208 13.5223L10.5733 13.4609L10.7614 11.1689Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.8048 10.6652L14.0556 10.6995L14.2436 14.8019L14.9929 14.7675L14.8048 10.6652Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.022 10.9198L13.2732 10.9621L13.4612 14.2886L14.21 14.2463L14.022 10.9198Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.2387 11.1689L12.4912 11.2303L12.6793 13.5223L13.4268 13.4609L13.2387 11.1689Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.98 14.495L11.249 14.3275L11.5584 12.977L12.2895 13.1445L11.98 14.495Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.5396 14.495L13.2707 14.3275L12.9613 12.977L12.2302 13.1445L12.5396 14.495Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.3541 14.4827H11.6041V13.1567H12.3541V14.4827Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.9761 11.1849L11.7258 11.2033L11.682 12.989L10.9323 12.9706L10.9761 11.1849Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.2804 11.1849L13.0302 11.2033L12.9863 12.989L12.2366 12.9706L12.2804 11.1849Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.0035 14.9421L10.1983 14.2179C10.994 14.4319 11.6051 14.5377 12.0217 14.5377C12.4384 14.5377 13.0494 14.4319 13.8452 14.2179L14.04 14.9421C13.1862 15.1717 12.5167 15.2877 12.0217 15.2877C11.5268 15.2877 10.8573 15.1717 10.0035 14.9421Z",
        fill: "#C09302"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.21175 10.667C9.16175 10.1716 9.45173 9.8362 9.94318 9.87898C10.1048 9.89304 10.2863 9.94085 10.528 10.0229C10.5986 10.0471 10.5986 10.0471 10.6673 10.0714C10.9996 10.1896 11.0898 10.22 11.1086 10.224C11.0349 10.2073 11.2518 9.81522 11.3015 9.74913C11.3074 9.7911 11.2825 9.78512 11.2225 9.77313L10.546 9.63773L11.0276 9.14367C11.1959 8.97097 11.4201 8.88533 11.6759 8.88533C11.7024 8.88533 11.7272 8.8841 11.8084 8.8791C11.8685 8.87545 11.8685 8.87545 11.9361 8.87265C12.4041 8.85748 12.7397 8.98982 12.7397 9.47106C12.7397 9.64322 12.7614 9.92009 12.7973 10.1301C12.8094 10.2008 12.8327 10.2669 12.7639 10.296C12.7668 10.2709 12.9307 10.2062 13.1856 10.0996L13.2162 10.0868C13.9567 9.77772 14.0433 9.74905 14.282 9.89413C14.4411 9.99081 14.5925 10.1647 14.7623 10.424L14.1348 10.8348C14.0253 10.6675 13.9381 10.5661 13.8966 10.5377C13.9909 10.6033 13.6732 10.7088 13.505 10.779L13.4749 10.7915C12.8983 11.0327 12.8223 11.0614 12.6575 11.0614C12.2088 11.0614 12.0477 10.6019 12.0036 9.94372C11.8652 10.3994 11.4522 10.9745 11.1119 10.9745C10.9629 10.9745 11.0345 10.998 10.4159 10.778C10.3511 10.7551 10.3511 10.7551 10.287 10.7331C10.0996 10.6695 9.96445 10.6339 9.87916 10.6262C9.88269 10.6222 9.89524 10.6087 9.90933 10.5966L9.21175 10.667Z",
        fill: "#C09302"
      })]
    })]
  })]
}));
//# sourceMappingURL=Egypt.js.map